import React from 'react';
import { Card, Descriptions, Typography } from '../../../components';

const { Text } = Typography;

export const ApplianceTags = ({ applianceProperties }) => {
    return (
        <Card title="Instance Tags" size="small">
            <Descriptions column={1} size="small">
                {Object.entries(applianceProperties.tags).map(([key, value]) => (
                    <Descriptions.Item label={key}>
                        <Text>{value}</Text>
                    </Descriptions.Item>
                ))}
            </Descriptions>
        </Card>
    );
};
